//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ReportMaterialsImageBtn from './ReportMaterialsImageBtn.vue'
import { canDeleteSegment } from './ReportMaterialsHelperFunctions.js'
import { createFieldConfig } from '../../../components/QSelectUtils.js'

import TableServer from '../../../components/Table/Table.vue'
import ItemsSearchField from '../../../components/Field/ItemsSearchField.vue'

export default {
  components: {
    ReportMaterialsImageBtn,
    TableServer,
    ItemsSearchField
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    disabledNote: {
      type: Boolean,
      default: false
    },
    displayRequestMaterialButton: {
      type: Boolean,
      default: false
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    showRowFn: {
      type: Function,
      default: () => {
        return true
      }
    },
    withoutBtns: {
      type: Boolean,
      default: false
    },
    tableName: {
      type: String,
      default: ''
    },
    projects: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 0
      },
      selectedItemsIds: [],
      selectedProject: [],
      openedChangeProjects: false,
      noted: [
        { key: 'hasNotes', name: 'Есть замечания' },
        { key: 'noNotes', name: 'Без замечаний' },
        { key: 'notChecked', name: 'Не проверено' }
      ],
      projectsFieldConfig: createFieldConfig({ allRecordsFn: this.getProjects })

    }
  },
  computed: {
    getSelectedItemsLength: function () {
      let length = 0
      for (let i = 0; i < this.itemsToShow.length; i++) {
        if (this.itemsToShow[i].isChecked) {
          length++
        }
      }
      return length
    },
    itemsToShow: function () {
      const itemsToShow = this.items.filter((item) => this.showRowFn(item))
      return itemsToShow
    }
  },
  watch: {
    getSelectedItemsLength: function (result) {
      this.$emit('selected-items', result)
    },
    'items.length': {
      handler: function () {
        for (let i = 0; i < this.itemsToShow.length; i++) {
          if (this.itemsToShow[i].isChecked === undefined) {
            this.$set(this.itemsToShow[i], 'isChecked', false)
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getProjects: function () {
      return Promise.resolve(this.projects)
    },
    canDeleteSegment: function () {
      return canDeleteSegment(this.report, this.tableName)
    },
    onSelectItem: function (item) {
      this.updateSelectedItemsIds()
    },
    onSelectAllItems: function () {
      for (let i = 0; i < this.itemsToShow.length; i++) {
        this.itemsToShow[i].isChecked = true
      }
      this.updateSelectedItemsIds()

      this.$q.notify({
        type: 'positive',
        message: 'Выбрано позиций: ' + this.selectedItemsIds.length,
        progress: true,
        timeout: 3000
      })
    },
    onClearSelection: function () {
      for (let i = 0; i < this.itemsToShow.length; i++) {
        this.itemsToShow[i].isChecked = false
      }
      this.updateSelectedItemsIds()
    },
    updateSelectedItemsIds: function () {
      this.selectedItemsIds = this.itemsToShow.filter(item => item.isChecked).map(item => item.recId)
    },
    onChangeProjects: function () {
      this.openedChangeProjects = true

      if (this.projects.length === 1) {
        this.selectedProject = this.projects[0]
      }
    },
    onSaveChangeProjects: function () {
      this.itemsToShow.forEach(item => {
        if (this.selectedItemsIds.includes(item.recId)) {
          if (this.selectedProject && this.selectedProject.projectKey) {
            item.projectKey = this.selectedProject.projectKey
            item.projectName = this.selectedProject.projectName
          } else {
            item.projectKey = null
            item.projectName = null
          }
        }
      })
      this.openedChangeProjects = false
    },
    approveSelectedItems: function () {
      for (let i = 0; i < this.itemsToShow.length; i++) {
        this.itemsToShow.map((item) => {
          if (item.isChecked) {
            item.noted = 'noNotes'
            item.note = null
            item.isChecked = false
          }
        })
      }
      this.updateSelectedItemsIds()
      this.$emit('remarks-changed')
    },
    onSelectedNoted: function (recId, noted) {
      const index = this.itemsToShow.findIndex((item) => item.recId == recId)
      if (noted === 'noNotes' || noted === 'notChecked') {
        this.itemsToShow[index].note = null
      }

      this.$emit('remarks-changed')
    },
    onChangeNote: function (recId) {
      const index = this.itemsToShow.findIndex((item) => item.recId == recId)
      const recordNote = this.itemsToShow.find((item) => item.recId == recId)
      if (recordNote.note && (recordNote.note !== '' || recordNote.note.trim().length > 0)) {
        this.itemsToShow[index].noted = 'hasNotes'
      }
      this.$emit('remarks-changed')
    },
    onRequestMaterial: function (row) {
      this.$emit('request-material', row)
    },
    onDeleteItem: function (row) {
      if (row.isSegment && !this.canDeleteSegment() && !this.$d_hasFullAccess()) {
        return
      }
      this.$emit('delete-item', row)
    },
    onEditItem: function (row) {
      if (row.isSegment) {
        return
      }
      this.$emit('edit-item', row)
    },
    getTrStyle: function (row) {
      if (row.noted === 'hasNotes') {
        return 'background-color: rgba(255,0,0,0.1);'
      } else if (row.noted === 'noNotes') {
        return 'background-color: rgba(0,255,0,0.1);'
      } else {
        return ''
      }
    },
    getListReportPath: function (val) {
      const obj = Object.entries(val)
      const nObj = obj.map(([key, value]) => [{ name: key, link: value }])
      return nObj
    }
  }
}

